import { render, staticRenderFns } from "./DetalleVentaTransporte.vue?vue&type=template&id=fa0a195a&scoped=true&"
import script from "./DetalleVentaTransporte.vue?vue&type=script&lang=js&"
export * from "./DetalleVentaTransporte.vue?vue&type=script&lang=js&"
import style0 from "./DetalleVentaTransporte.vue?vue&type=style&index=0&id=fa0a195a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0a195a",
  null
  
)

export default component.exports